import { render, staticRenderFns } from "./RecursoGrupo.vue?vue&type=template&id=2cf9a08a&scoped=true"
import script from "./RecursoGrupo.vue?vue&type=script&lang=js"
export * from "./RecursoGrupo.vue?vue&type=script&lang=js"
import style0 from "./RecursoGrupo.vue?vue&type=style&index=0&id=2cf9a08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9a08a",
  null
  
)

export default component.exports